module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-row col-12",
    class: {
      error: _vm.error
    }
  }, [_c('div', {
    staticClass: "row d-flex align-items-center"
  }, [_c('label', {
    staticClass: "col-12 col-sm"
  }, [_vm._t("label"), _vm._v(" "), (_vm.required) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-9"
  }, [_vm._t("input")], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.error))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52633892","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Form/DefaultBaseInput.vue
// module id = 3183
// module chunks = 0